import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Message, Label, Divider } from 'semantic-ui-react';
import { campaignStatus, getCampaignStatus } from '../../utils/campaign-status';

const OnLabel = () => (<Label color="green" basic>ON</Label>);
const OffLabel = () => (<Label color="grey" basic>OFF</Label>);

const MicroSettings = ({ isStickerScannerOn, useEstimatedReachAndImpressions }) => (
  <div>
    <p style={{ textAlign: 'right', paddingBottom: '5px' }}>
      capture stories: {isStickerScannerOn ? <OnLabel /> : <OffLabel />}
    </p>
    <p style={{ textAlign: 'right' }}>
      estimate R&I: {useEstimatedReachAndImpressions ? <OnLabel /> : <OffLabel />}
    </p>
  </div>
);

const CampaignLiveStatus = ({
  campaign,
}) => {
  //
  const campaignId = _.get(campaign, 'id');

  const liveDate = _.get(campaign, 'liveDate', null);
  const endDate = _.get(campaign, 'endDate', null);

  const isStickerScannerOn = _.get(campaign, 'scanUnauthorisedStories', false);
  const useEstimatedReachAndImpressions = _.get(campaign, 'useEstimatedReachAndImpressions', false);

  const captureAllStories = _.get(campaign, 'captureAllStories', false);
  const captureAllStoriesWhenMatched = _.get(campaign, 'captureAllStoriesWhenMatched', false);

  const startMoment = moment(liveDate);
  const endMoment = moment(endDate);

  const status = getCampaignStatus(campaign);

  if (status === campaignStatus.INVALID) {
    return (
      <Message
        color="orange"
        icon="warning circle"
        header="Campaign is not tracking."
        content={
          <div>
            { _.isNil(liveDate) ? 'Live date' : 'End date' } is not set.&nbsp;
            <Link className="dyzio-green-link" to={`/campaign/${campaignId}/settings`}>Click here to edit dates.</Link>
          </div>
        }
      />
    );
  }
  if (status === campaignStatus.FUTURE) { // NOT STARTED YET
    return (
      <table width="100%">
        <tr>
          <td>
            <Message
              color="orange"
              icon="wait"
              header="This campaign has NOT STARTED yet"
              content={
                <div>Start date: {startMoment.format('LL')}.&nbsp;
                  <Link className="dyzio-green-link" to={`/campaign/${campaignId}/settings`}>
                    Click here to edit dates.
                  </Link>
                </div>
              }
            />
          </td>
          <td width="200">
            <MicroSettings
              useEstimatedReachAndImpressions={useEstimatedReachAndImpressions}
              isStickerScannerOn={isStickerScannerOn}
            />
          </td>
        </tr>
        { captureAllStories &&
          <tr>
            <Divider />
            <Message
              color="red"
              icon="lightning"
              header="CAPTURE ALL STORIES IS ON"
              content={
                <div>
                All stories will be captured for this campaign. This will create a lot of data, which will require processing.
                </div>
              }
            />
          </tr>
        }
      </table>
    );
  }

  if (status === campaignStatus.LIVE) { // is live
    return (
      <table width="100%">
        <tr>
          <td>
            <Message
              success
              icon="play circle outline"
              header="This campaign is LIVE"
              content={
                <div>End date: {endMoment.format('LL')}.&nbsp;
                  <Link className="dyzio-green-link" to={`/campaign/${campaignId}/settings`}>
                    Click here to edit dates.
                  </Link>
                </div>
              }
            />
          </td>
          <td width="200">
            <MicroSettings
              useEstimatedReachAndImpressions={useEstimatedReachAndImpressions}
              isStickerScannerOn={isStickerScannerOn}
            />
          </td>
        </tr>
        { captureAllStories &&
          <tr>
            <Divider />
            <Message
              color="red"
              icon="lightning"
              header="CAPTURE ALL STORIES IS ON"
              content={
                <div>
                All stories will be captured for this campaign. This will create a lot of data, which will require processing.
                </div>
              }
            />
          </tr>
        }
      </table>
    );
  }
  if (status === campaignStatus.COMPLETED) {
    return (
      <Message
        color="orange"
        icon="flag"
        header="This campaign is COMPLETE"
        content={
          <div>End date: {endMoment.format('LL')}.&nbsp;
            <Link className="dyzio-green-link" to={`/campaign/${campaignId}/settings`}>Click here to edit dates.</Link>
          </div>
        }
      />
    );
  }
  return null;
};

CampaignLiveStatus.propTypes = {
  campaign: PropTypes.object.isRequired,
};

export default CampaignLiveStatus;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-live-status/index.js
 **/